import { storageGetItem } from '@/utils/storage';
export default function checkLogin() {
  if (typeof window === 'undefined') {
    return false;
  }
  const user = storageGetItem('user');
  const token = storageGetItem('token');
  return user !== null && Boolean(token);
}